import React from 'react'
import { connect } from 'react-redux'
import { ThemeProvider } from '@material-ui/styles';
import { theme } from '../assets/theme'
import {
    Route,
    Switch,
    withRouter
} from 'react-router-dom'
import { isEqual, isEmpty } from 'lodash'
import { publicRoutes } from './routes'
import { saveToken, getRequestState, updateShowAppRequirement } from '../shared/actions'
import { saveLanguage, saveLanguageJSON, getSupportedLanguages } from '../screens/language/actions'
import { saveSelfie } from '../screens/selfie/actions'
import { saveIDProof, saveIDProofBackSide, saveIDProofFrontSide } from '../screens/idProof/actions'
import { saveIDPhoto } from '../screens/idPhoto/actions'
import { saveHomeImage } from '../screens/homeImage/actions'
import { saveVideo } from '../screens/video/actions'
import { saveAddressProof, saveAddressProofBackSide, saveAddressProofFrontSide } from '../screens/addressProof/actions'
import { stateRouteMapping, stateRouteMappingV2 } from '../shared/constants';
import { getURLByKey, getJSON } from '../utils/helper';
import { CheckAppRequirement, DialogsManagement } from '../shared'
import ActivityLoader from '../shared/ActivityLoader'

class Navigation extends React.Component {

    componentDidMount = () => {
        this.props.getRequestState()
        this.props.getSupportedLanguages()
    }

    componentDidUpdate = (prevProps) => {
        const { requestState, history } = this.props
        if (!isEqual(prevProps.requestState, requestState) && !isEmpty(requestState)) {
            if (requestState.state === "candidate_availability_captured") {
                if (requestState.data && requestState.data["availability"] === "available") {
                    history.push("documents")
                } if (requestState.data && requestState.data["not_available_reason"] === "forward_to_parents") {
                    history.push("selfie")
                }
            } else {
                if(requestState.template.version === 1){
                    history.push(stateRouteMappingV2[requestState.state])
                }
                else {
                    history.push(stateRouteMapping[requestState.state])
                }
            }
            if (requestState.state !== 'initiated') {
                this.props.updateShowAppRequirement(true)
            }
            if (!isEmpty(requestState.data)) {
                Object.keys(requestState.data).forEach(item => {
                    if (item === "language") {
                        this.props.saveLanguage(requestState.data[item])
                    } else if (item === "selfie") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveSelfie(data.url)
                        })
                    } else if (item === "id_type") {
                        this.props.saveIDProof(requestState.data[item])
                    } else if (item === "id_backside") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveIDProofBackSide(data.url)
                        })
                    } else if (item === "id_frontside") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveIDProofFrontSide(data.url)
                        })
                    } else if (item === "photo_with_id") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveIDPhoto(data.url)
                        })
                    } else if (item === "address_proof_type") {
                        this.props.saveAddressProof(requestState.data[item])
                    } else if (item === "address_proof_backside") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveAddressProofBackSide(data.url)
                        })
                    } else if (item === "address_proof_frontside") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveAddressProofFrontSide(data.url)
                        })
                    } else if (item === "home_image") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveHomeImage(data.url)
                        })
                    } 
                    else if (item === "home_video") {
                        getURLByKey(requestState.data[item], this.props.token, (data) => {
                            this.props.saveVideo(data.url)
                        })
                    }
                })
            }
        }
        if (!isEqual(prevProps.language, this.props.language) && this.props.language && !isEmpty(this.props.supportedLanguages)) {
            this.setState({ selectedLanguage: this.props.language })
            let selectedLanguage = this.props.supportedLanguages.find(item => item.language === this.props.language)
            if (selectedLanguage) {
                getJSON(selectedLanguage.url, (response) => {
                    this.props.saveLanguageJSON(response)
                })
            }
        }
        if (!isEqual(prevProps.supportedLanguages, this.props.supportedLanguages) && this.props.language && !isEmpty(this.props.supportedLanguages)) {
            let selectedLanguage = this.props.supportedLanguages.find(item => item.language === this.props.language)
            if (selectedLanguage) {
                getJSON(selectedLanguage.url, (response) => {
                    this.props.saveLanguageJSON(response)
                })
            }
        }
    }

    render() {
        return (
            <ThemeProvider theme={theme}>
                <div>
                    {this.props.showAppRequirement && <CheckAppRequirement />}
                    <ActivityLoader />
                    <DialogsManagement />
                    <Switch>
                        {publicRoutes && publicRoutes.map((item, index) => <Route key={index} exact path={item.path} component={item.component} />)}
                    </Switch>
                </div>
            </ThemeProvider>
        )
    }
}

const mapStateToProps = ({ shared: { requestState, token, showAppRequirement }, router, language: { language, supportedLanguages } }) => {
    return {
        token,
        router,
        requestState,
        language,
        supportedLanguages,
        showAppRequirement
    }
}

const mapDispatchToProps = {
    saveToken,
    getRequestState,
    saveLanguage,
    saveSelfie,
    saveIDProof,
    saveIDProofBackSide,
    saveIDProofFrontSide,
    saveIDPhoto,
    saveAddressProof,
    saveAddressProofBackSide,
    saveAddressProofFrontSide,
    saveHomeImage,
    saveVideo,
    saveLanguageJSON,
    getSupportedLanguages,
    updateShowAppRequirement
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation))
